/** Saving a text the page made as a file of the computer (the browser's download). */

/** Downloads `text` as a file named `name`, of type `type`. */
export function downloadText(name: string, text: string, type = "text/plain"): void {
  const url = URL.createObjectURL(new Blob([text], { type: `${type};charset=utf-8` }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  // The download has its copy once the click is handled.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Downloads `bytes` as a file named `name`, of type `type`. */
export function downloadBytes(name: string, bytes: Uint8Array, type = "application/octet-stream"): void {
  const url = URL.createObjectURL(new Blob([bytes as BlobPart], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
